import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import _ from 'underscore';
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, minLength, integer, minValue, maxValue, email } from 'vuelidate/lib/validators';
import { FinnishBusinessIds } from 'finnish-business-ids';
import { FinnishSSN } from 'finnish-ssn';
import IBAN from 'iban';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

//
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap); // Fromatters

function formatBusinessID(businessID) {
  let lastChar = businessID[businessID.length - 1];
  let firstPart = businessID.substring(0, businessID.length - 1);
  return firstPart + '-' + lastChar;
}

function formatPhoneNumber(phone) {
  let prefix = '+358';
  phone = phone.replace('-', '');
  phone = phone.replace(' ', '');

  if (phone.charAt(0) === '0') {
    phone = prefix + phone.substr(1);
  } else if (phone.startsWith('358')) {
    phone = '+' + phone;
  } else if (phone.charAt(0) === '1' || phone.charAt(0) === '2' || phone.charAt(0) === '3' || phone.charAt(0) === '4' || phone.charAt(0) === '5' || phone.charAt(0) === '6' || phone.charAt(0) === '7' || phone.charAt(0) === '8' || phone.charAt(0) === '9') {
    phone = prefix + phone;
  }

  return phone;
} // Constants


const loanSumOptions = [{
  value: '1000',
  text: '1 000 €'
}, {
  value: '2000',
  text: '2 000 €'
}, {
  value: '3000',
  text: '3 000 €'
}, {
  value: '4000',
  text: '4 000 €'
}, {
  value: '5000',
  text: '5 000 €'
}, {
  value: '6000',
  text: '6 000 €'
}, {
  value: '7000',
  text: '7 000 €'
}, {
  value: '8000',
  text: '8 000 €'
}, {
  value: '9000',
  text: '9 000 €'
}, {
  value: '10000',
  text: '10 000 €'
}, {
  value: '11000',
  text: '11 000 €'
}, {
  value: '12000',
  text: '12 000 €'
}, {
  value: '13000',
  text: '13 000 €'
}, {
  value: '14000',
  text: '14 000 €'
}, {
  value: '15000',
  text: '15 000 €'
}, {
  value: '16000',
  text: '16 000 €'
}, {
  value: '17000',
  text: '17 000 €'
}, {
  value: '18000',
  text: '18 000 €'
}, {
  value: '19000',
  text: '19 000 €'
}, {
  value: '20000',
  text: '20 000 €'
}, {
  value: '21000',
  text: '21 000 €'
}, {
  value: '22000',
  text: '22 000 €'
}, {
  value: '23000',
  text: '23 000 €'
}, {
  value: '24000',
  text: '24 000 €'
}, {
  value: '25000',
  text: '25 000 €'
}, {
  value: '26000',
  text: '26 000 €'
}, {
  value: '27000',
  text: '27 000 €'
}, {
  value: '28000',
  text: '28 000 €'
}, {
  value: '29000',
  text: '29 000 €'
}, {
  value: '30000',
  text: '30 000 €'
}, {
  value: '35000',
  text: '35 000 €'
}, {
  value: '40000',
  text: '40 000 €'
}, {
  value: '45000',
  text: '45 000 €'
}, {
  value: '50000',
  text: '50 000 €'
}, {
  value: '55000',
  text: '55 000 €'
}, {
  value: '60000',
  text: '60 000 €'
}, {
  value: '65000',
  text: '65 000 €'
}, {
  value: '70000',
  text: '70 000 €'
}, {
  value: '80000',
  text: '80 000 €'
}, {
  value: '90000',
  text: '90 000 €'
}, {
  value: '100000',
  text: '100 000 €'
}, {
  value: '110000',
  text: '110 000 €'
}, {
  value: '120000',
  text: '120 000 €'
}, {
  value: '130000',
  text: '130 000 €'
}, {
  value: '140000',
  text: '140 000 €'
}, {
  value: '150000',
  text: '150 000 €'
}, {
  value: '160000',
  text: '160 000 €'
}, {
  value: '170000',
  text: '170 000 €'
}, {
  value: '180000',
  text: '180 000 €'
}, {
  value: '190000',
  text: '190 000 €'
}, {
  value: '200000',
  text: '200 000 €'
}, {
  value: '210000',
  text: '210 000 €'
}, {
  value: '220000',
  text: '220 000 €'
}, {
  value: '230000',
  text: '230 000 €'
}, {
  value: '240000',
  text: '240 000 €'
}, {
  value: '250000',
  text: '250 000 €'
}, {
  value: '300000',
  text: '300 000 €'
}, {
  value: '325000',
  text: '325 000 €'
}, {
  value: '350000',
  text: '350 000 €'
}, {
  value: '375000',
  text: '375 000 €'
}, {
  value: '400000',
  text: '400 000 €'
}, {
  value: '450000',
  text: '450 000 €'
}, {
  value: '500000',
  text: '500 000 €'
}, {
  value: '550000',
  text: '550 000 €'
}, {
  value: '600000',
  text: '600 000 €'
}, {
  value: '700000',
  text: '700 000 €'
}, {
  value: '800000',
  text: '800 000 €'
}, {
  value: '900000',
  text: '900 000 €'
}, {
  value: '1000000',
  text: '1 000 000 €'
}, {
  value: '1250000',
  text: '1 250 000 €'
}, {
  value: '1500000',
  text: '1 500 000 €'
}, {
  value: '1750000',
  text: '1 750 000 €'
}, {
  value: '2000000',
  text: '2 000 000 €'
}, {
  value: '2250000',
  text: '2 250 000 €'
}, {
  value: '2500000',
  text: '2 500 000 €'
}, {
  value: '2750000',
  text: '2 750 000 €'
}, {
  value: '3000000',
  text: '3 000 000 €'
}, {
  value: '3250000',
  text: '3 250 000 €'
}, {
  value: '3500000',
  text: '3 500 000 €'
}, {
  value: '3750000',
  text: '3 750 000 €'
}, {
  value: '4000000',
  text: '4 000 000 €'
}, {
  value: '4250000',
  text: '4 250 000 €'
}, {
  value: '4500000',
  text: '4 500 000 €'
}, {
  value: '4750000',
  text: '4 750 000 €'
}, {
  value: '5000000',
  text: '5 000 000 €'
}, {
  value: '5250000',
  text: '5 250 000 €'
}, {
  value: '5500000',
  text: '5 500 000 €'
}, {
  value: '5750000',
  text: '5 750 000 €'
}, {
  value: '6000000',
  text: '6 000 000 €'
}, {
  value: '6250000',
  text: '6 250 000 €'
}, {
  value: '6500000',
  text: '6 500 000 €'
}, {
  value: '6750000',
  text: '6 750 000 €'
}, {
  value: '7000000',
  text: '7 000 000 €'
}, {
  value: '7250000',
  text: '7 250 000 €'
}, {
  value: '7500000',
  text: '7 500 000 €'
}, {
  value: '7750000',
  text: '7 750 000 €'
}, {
  value: '8000000',
  text: '8 000 000 €'
}];
const limitedLoanTimeOptions = [{
  value: '2',
  text: '3 kk'
}, {
  value: '6',
  text: '6 kk'
}, {
  value: '9',
  text: '9 kk'
}, {
  value: '12',
  text: '12 kk'
}, {
  value: '18',
  text: '18 kk'
}, {
  value: '24',
  text: '24 kk'
}];
const middleLoanTimeOptions = [{
  value: '2',
  text: '3 kk'
}, {
  value: '6',
  text: '6 kk'
}, {
  value: '9',
  text: '9 kk'
}, {
  value: '12',
  text: '12 kk'
}, {
  value: '18',
  text: '18 kk'
}, {
  value: '24',
  text: '24 kk'
}, {
  value: '36',
  text: '3 vuotta'
}];
const loanTimeOptions = [{
  value: '2',
  text: '3 kk'
}, {
  value: '6',
  text: '6 kk'
}, {
  value: '9',
  text: '9 kk'
}, {
  value: '12',
  text: '12 kk'
}, {
  value: '18',
  text: '18 kk'
}, {
  value: '24',
  text: '24 kk'
}, {
  value: '36',
  text: '3 vuotta'
}, {
  value: '48',
  text: '4 vuotta'
}, {
  value: '60',
  text: '5 vuotta'
}, {
  value: '72',
  text: '6 vuotta'
}, {
  value: '84',
  text: '7 vuotta'
}, {
  value: '96',
  text: '8 vuotta'
}]; // Custom validators

const validSSN = value => FinnishSSN.validate(value.toUpperCase());

const validBID = value => FinnishBusinessIds.isValidBusinessId(value);

const validPhoneNumber = value => /^[\d-()]{6,15}$/g.test(value);

const validIBAN = value => IBAN.isValid(value);

const validPostalCode = value => /^[\d-()]{5}$/g.test(value);

const isTrue = value => value === true;

var script = {
  components: {
    VueTypeaheadBootstrap,
    Loading
  },
  mixins: [validationMixin],
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    initialStep: {
      type: Number,
      required: false
    },
    initialForm: {
      type: Object,
      required: false,
      default: function () {
        return {
          loanAmount: 50000,
          loanTime: 12,
          phone: '',
          companyName: '',
          businessID: '',
          iban: '',
          turnover: null,
          yearFounded: null,
          address: '',
          postalCode: '',
          ssn: '',
          firstName: '',
          lastName: '',
          tos: false,
          sellingBill: false
        };
      }
    },
    buttonVariant: {
      type: String,
      required: false
    },
    tosUrl: {
      type: String,
      required: true
    },
    errorMessage: {
      type: String,
      required: false
    },
    errors: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    },
    disabledFields: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    },
    showArrow: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      }
    },
    buttonText1: {
      type: String,
      required: false,
      default: function () {
        return 'Hae lainaa';
      }
    },
    buttonText2: {
      type: String,
      required: false,
      default: function () {
        return 'Lähetä';
      }
    }
  },
  name: 'CompanyLoanForm',

  data() {
    return {
      form: {
        loanAmount: this.initialForm.loanAmount,
        loanTime: this.initialForm.loanTime,
        email: this.initialForm.email,
        phone: this.initialForm.phone,
        companyName: this.initialForm.companyName,
        businessID: this.initialForm.businessID,
        iban: this.initialForm.iban,
        turnover: this.initialForm.turnover,
        yearFounded: this.initialForm.yearFounded,
        address: this.initialForm.address,
        postalCode: this.initialForm.postalCode,
        ssn: this.initialForm.ssn,
        firstName: this.initialForm.firstName,
        lastName: this.initialForm.lastName,
        tos: this.initialForm.tos,
        sellingBill: this.initialForm.sellingBill
      },
      step: this.initialStep ? this.initialStep : 1,
      company: null,
      loanAmountOptions: loanSumOptions,
      loanTimeOptions: middleLoanTimeOptions,
      companies: [],
      api: `${this.apiUrl}/services/business-info`,
      searchLoading: false,
      companyLoading: false,
      buttonVariantData: this.buttonVariant ? this.buttonVariant : 'primary',
      errorList: this.errors,
      disabledFieldsList: this.disabledFields
    };
  },

  computed: {},
  methods: {
    updateLoanTimeOptions(amount) {
      /*
       * Allow longer loan repayment times if the loan amount is
       * more than 250k€.
       */
      if (amount < 50000) {
        this.loanTimeOptions = limitedLoanTimeOptions;

        if (this.form.loanTime > 24) {
          this.form.loanTime = 24;
        }
      } else if (amount >= 300000) {
        this.loanTimeOptions = loanTimeOptions;
      } else {
        this.loanTimeOptions = middleLoanTimeOptions;

        if (this.form.loanTime > 36) {
          this.form.loanTime = 36;
        }
      }
    },

    async getCompanies(query) {
      /*
       * Get 10 search results from API to show in the suggestions.
       */
      if (query.length > 2) {
        this.searchLoading = true;
        const payload = {
          search_term: query,
          search_by: 'company_name'
        };
        await axios.post(`${this.api}/search/`, payload).then(res => {
          const companies = res.data.companies;
          this.companies = companies;
          this.searchLoading = false;
        }).catch(error => {
          if (error) {
            this.searchLoading = false;
          }
        });
      }
    },

    async selectCompany(company) {
      /*
       * When selecting company:
       * 1. Go to next step
       * 2. Get selected company details
       * 3. Pre-fill the forms
       * 4. Emit 'nextStep' event
       */
      this.step = 2;
      this.company = company;
      this.companyLoading = true;
      await axios.get(`${this.api}/${this.company.business_id}/form-info/`).then(res => {
        const company = res.data;
        this.company = company;
        this.companyLoading = false;
        this.form.companyName = this.company.name;
        this.form.businessID = formatBusinessID(this.company.business_id);
        this.form.turnover = this.company.turnover ? parseInt(this.company.turnover) : null;
        this.form.yearFounded = this.company.year_founded ? parseInt(this.company.year_founded) : null;
        this.form.address = this.company.address.address;
        this.form.postalCode = this.company.address.postal_code;
        this.$emit('nextStep');
      }).catch(error => {
        if (error) {
          this.companyLoading = false;
          this.$emit('nextStep');
        }
      });
    },

    nextStep(event) {
      /*
       * When clicking button without selecting company first go to
       * next step, and then emit 'nextStep' event.
       */
      event.preventDefault();
      this.step = 2;
      this.$emit('nextStep');
    },

    onSubmit() {
      /*
       * When submitting the form, first check that form is valid
       * and then emit 'submit' hook.
       */
      this.$v.form.$touch();

      if (!this.$v.form.$anyError) {
        this.$emit('submit');
      }
    },

    validateState(name) {
      /*
       * Validation method.
       */
      const {
        $dirty,
        $error
      } = this.$v.form[`${name}`]; // Backend errors.

      if (this.errorList.includes(name)) {
        return false;
      } // Vuelidate validation.


      return $dirty ? !$error : null;
    },

    cleanError(name) {
      /*
       * Clean error from errorList.
       */
      this.errorList = this.errorList.filter(val => {
        return val !== name;
      });
    },

    show(field) {
      /*
       * If the field not in disabledFields prop.
       */
      return !this.disabledFieldsList.includes(field);
    }

  },
  watch: {
    // Watch companyName for changes so we can give suggestions.
    'form.companyName': _.debounce(function (name) {
      this.cleanError('companyName');
      this.getCompanies(name);
    }, 400),
    // Backend error cleaning on change
    'form.loanAmount': function () {
      this.cleanError('loanAmount');
    },
    'form.loanTime': function () {
      this.cleanError('loanTime');
    },
    'form.businessID': function () {
      this.cleanError('businessID');
    },
    'form.yearFounded': function () {
      this.cleanError('yearFounded');
    },
    'form.turnover': function () {
      this.cleanError('turnover');
    },
    'form.iban': function () {
      this.cleanError('iban');
    },
    'form.address': function () {
      this.cleanError('address');
    },
    'form.postalCode': function () {
      this.cleanError('postalCode');
    },
    'form.firstName': function () {
      this.cleanError('firstName');
    },
    'form.lastName': function () {
      this.cleanError('lastName');
    },
    'form.email': function () {
      this.cleanError('email');
    },
    'form.phone': function () {
      this.cleanError('phone');
    },
    'form.ssn': function () {
      this.cleanError('ssn');
    },
    'form.tos': function () {
      this.cleanError('tos');
    },
    'form.sellingBill': function () {
      this.cleanError('sellingBill');
    },
    // Event emitting
    form: {
      handler: function (form) {
        /*
         * Clean form output and emit event always when form changes.
         */
        let formatted = Object.assign({}, form); // Clean SSN.

        formatted.ssn = formatted.ssn.toUpperCase(); // Clean phone number.

        formatted.phone = formatPhoneNumber(formatted.phone); // Emit event.

        this.$emit('update', formatted);
      },
      deep: true
    },
    // Watch for errors prop and update state
    errors: function () {
      this.errorList = this.errors;
    },
    // Select company if only one choice
    companies: function (companies) {
      if (this.step === 1 && companies.length === 1) {
        let selectedCompany = companies[0];
        this.form.companyName = selectedCompany.official_name;
        this.$refs.typeahead.inputValue = selectedCompany.official_name;
        let el = document.querySelector(':focus');
        if (el) el.blur();
        this.selectCompany(selectedCompany);
      }
    }
  },

  // Vuelidate validators
  validations() {
    let form = {
      companyName: {
        required,
        minLength: minLength(3)
      },
      email: {},
      phone: {},
      businessID: {},
      yearFounded: {},
      turnover: {},
      iban: {},
      address: {},
      postalCode: {},
      firstName: {},
      lastName: {},
      ssn: {},
      tos: {}
    };

    if (this.show('email')) {
      form.email = {
        required,
        email
      };
    }

    if (this.show('phone')) {
      form.phone = {
        required,
        validPhoneNumber
      };
    }

    if (this.show('businessID')) {
      form.businessID = {
        required,
        validBID
      };
    }

    if (this.show('yearFounded')) {
      form.yearFounded = {
        required,
        integer,
        minValue: minValue(1600),
        maxValue: maxValue(new Date().getFullYear())
      };
    }

    if (this.show('turnover')) {
      form.turnover = {
        required,
        minValue: minValue(0),
        integer
      };
    }

    if (this.show('iban')) {
      form.iban = {
        validIBAN
      };
    }

    if (this.show('address')) {
      form.address = {
        required,
        minLength: minLength(3)
      };
    }

    if (this.show('postalCode')) {
      form.postalCode = {
        required,
        validPostalCode
      };
    }

    if (this.show('firstName')) {
      form.firstName = {
        required,
        minLength: minLength(2)
      };
    }

    if (this.show('lastName')) {
      form.lastName = {
        required,
        minLength: minLength(2)
      };
    }

    if (this.show('ssn')) {
      form.ssn = {
        required,
        validSSN
      };
    }

    if (this.show('tos')) {
      form.tos = {
        required,
        isTrue
      };
    }

    return {
      form: form
    };
  },

  mounted: function () {
    /*
     * Set suggestive company name value on mount.
     */
    this.$refs.typeahead.inputValue = this.companyName;
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "CompanyLoanForm"
  }, [_c('div', {
    staticClass: "vld-parent"
  }, [_c('loading', {
    attrs: {
      "active": _vm.companyLoading
    },
    on: {
      "update:active": function ($event) {
        _vm.companyLoading = $event;
      }
    }
  })], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "company-details"
  }, [_c('b-row', [_vm.show('loanAmount') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "loan-amount-group",
      "label": "Lainasumma",
      "label-for": "loan-amount"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "loan-amount",
      "options": _vm.loanAmountOptions
    },
    on: {
      "change": _vm.updateLoanTimeOptions
    },
    model: {
      value: _vm.form.loanAmount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "loanAmount", $$v);
      },
      expression: "form.loanAmount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm.show('loanTime') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "loan-time-group",
      "label": "Laina-aika",
      "label-for": "loan-time"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "loan-time",
      "options": _vm.loanTimeOptions
    },
    model: {
      value: _vm.form.loanTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "loanTime", $$v);
      },
      expression: "form.loanTime"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_vm.show('companyName') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "company-name-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "company-name"
    }
  }, [_vm._v("\n              Yrityksen nimi\n              "), _vm.searchLoading ? _c('b-icon', {
    attrs: {
      "icon": "arrow-clockwise",
      "animation": "spin"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('vue-typeahead-bootstrap', {
    ref: "typeahead",
    attrs: {
      "id": "company-name",
      "data": _vm.companies,
      "serializer": function (s) {
        return s.official_name;
      }
    },
    on: {
      "hit": function ($event) {
        return _vm.selectCompany($event);
      }
    },
    model: {
      value: _vm.form.companyName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "companyName", $$v);
      },
      expression: "form.companyName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm.step === 2 && _vm.show('businessID') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "business-id-group",
      "label": "Y-tunnus",
      "label-for": "business-id"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "business-id",
      "state": _vm.validateState('businessID'),
      "aria-describedby": "business-id-live-feedback"
    },
    model: {
      value: _vm.$v.form.businessID.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.businessID, "$model", $$v);
      },
      expression: "$v.form.businessID.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "business-id-live-feedback"
    }
  }, [_vm._v("Tarkista y-tunnus.\n            ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _vm.step === 2 ? _c('b-row', [_vm.show('yearFounded') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "year-founded-group",
      "label": "Perustamisvuosi",
      "label-for": "year-founded"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "year",
      "type": "number",
      "min": "1600",
      "max": new Date().getFullYear(),
      "state": _vm.validateState('yearFounded'),
      "aria-describedby": "year-founded-live-feedback"
    },
    model: {
      value: _vm.$v.form.yearFounded.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.yearFounded, "$model", $$v);
      },
      expression: "$v.form.yearFounded.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "year-founded-live-feedback"
    }
  }, [_vm._v("Tarkista perustamisvuosi.\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm.show('turnover') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "turnover-group",
      "label": "Liikevaihto",
      "label-for": "turnover"
    }
  }, [_c('b-input-group', {
    attrs: {
      "prepend": "€"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "turnover",
      "min": "0",
      "type": "number",
      "state": _vm.validateState('turnover'),
      "aria-describedby": "turnover-live-feedback"
    },
    model: {
      value: _vm.$v.form.turnover.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.turnover, "$model", $$v);
      },
      expression: "$v.form.turnover.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "turnover-live-feedback"
    }
  }, [_vm._v("Tarkista liikevaihto.\n              ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.step === 2 && _vm.show('iban') ? _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "iban-group",
      "label": "Tilinumero",
      "label-for": "iban"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "iban",
      "state": _vm.validateState('iban'),
      "aria-describedby": "iban-live-feedback"
    },
    model: {
      value: _vm.$v.form.iban.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.iban, "$model", $$v);
      },
      expression: "$v.form.iban.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "iban-live-feedback"
    }
  }, [_vm._v("Tarkista tilinumero.\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm.step === 2 ? _c('b-row', [_vm.show('address') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "address-group",
      "label": "Osoite",
      "label-for": "address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "address",
      "state": _vm.validateState('address'),
      "aria-describedby": "address-live-feedback"
    },
    model: {
      value: _vm.$v.form.address.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.address, "$model", $$v);
      },
      expression: "$v.form.address.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "address-live-feedback"
    }
  }, [_vm._v("Tarkista osoite.\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm.show('postalCode') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "postal-code-group",
      "label": "Postinumero",
      "label-for": "postal-code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "postal-code",
      "state": _vm.validateState('postalCode'),
      "aria-describedby": "postal-code-live-feedback"
    },
    model: {
      value: _vm.$v.form.postalCode.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.postalCode, "$model", $$v);
      },
      expression: "$v.form.postalCode.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "postal-code-live-feedback"
    }
  }, [_vm._v("Tarkista postinumero.\n            ")])], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "personal-details"
  }, [_vm.step === 2 && _vm.show('personalDetailsHeader') ? _c('h2', [_vm._v("Hakija")]) : _vm._e(), _vm._v(" "), _vm.step === 2 ? _c('b-row', [_vm.show('firstName') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "first-name-group",
      "label": "Etunimi",
      "label-for": "first-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "first-name",
      "state": _vm.validateState('firstName'),
      "aria-describedby": "first-name-live-feedback"
    },
    model: {
      value: _vm.$v.form.firstName.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.firstName, "$model", $$v);
      },
      expression: "$v.form.firstName.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "first-name-live-feedback"
    }
  }, [_vm._v("Tarkista etunimi.\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm.show('lastName') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "last-name-group",
      "label": "Sukunimi",
      "label-for": "last-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "last-name",
      "state": _vm.validateState('lastName'),
      "aria-describedby": "last-name-live-feedback"
    },
    model: {
      value: _vm.$v.form.lastName.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.lastName, "$model", $$v);
      },
      expression: "$v.form.lastName.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "last-name-live-feedback"
    }
  }, [_vm._v("Tarkista sukunimi.\n            ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_vm.show('email') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "email-group",
      "label": "Sähköposti",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "state": _vm.validateState('email'),
      "aria-describedby": "email-live-feedback"
    },
    model: {
      value: _vm.$v.form.email.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.email, "$model", $$v);
      },
      expression: "$v.form.email.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "email-live-feedback"
    }
  }, [_vm._v("Tarkista sähköpostiosoite.\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm.show('phone') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "phone-group",
      "label": "Puhelinnumero",
      "label-for": "phone"
    }
  }, [_c('b-input-group', {
    attrs: {
      "prepend": "+358"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "phone",
      "state": _vm.validateState('phone'),
      "aria-describedby": "phone-live-feedback"
    },
    model: {
      value: _vm.$v.form.phone.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.phone, "$model", $$v);
      },
      expression: "$v.form.phone.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "phone-live-feedback"
    }
  }, [_vm._v("Tarkista puhelinnumero.\n              ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _vm.step === 2 ? _c('b-row', [_vm.show('ssn') ? _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "ssn-group",
      "label": "Henkilötunnus",
      "label-for": "ssn"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "ssn",
      "state": _vm.validateState('ssn'),
      "aria-describedby": "ssn-live-feedback"
    },
    model: {
      value: _vm.$v.form.ssn.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.ssn, "$model", $$v);
      },
      expression: "$v.form.ssn.$model"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "ssn-live-feedback"
    }
  }, [_vm._v("Tarkista henkilötunnus.\n            ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.step === 2 && _vm.show('tos') ? _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tos-group"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "tos",
      "state": _vm.validateState('tos'),
      "aria-describedby": "tos-live-feedback"
    },
    model: {
      value: _vm.$v.form.tos.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form.tos, "$model", $$v);
      },
      expression: "$v.form.tos.$model"
    }
  }, [_vm._v("\n              Hyväksyn "), _c('a', {
    attrs: {
      "href": _vm.tosUrl,
      "target": "_blank"
    }
  }, [_vm._v("käyttöehdot")])]), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "tos-live-feedback",
      "state": _vm.validateState('tos')
    }
  }, [_vm._v("Käyttöehdot on hyväksyttävä.\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm.step === 2 && _vm.show('sellingBill') ? _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "selling-bill-group"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "selling-bill",
      "name": "sellingBill"
    },
    model: {
      value: _vm.form.sellingBill,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sellingBill", $$v);
      },
      expression: "form.sellingBill"
    }
  }, [_vm._v("\n              Haluan muuttaa laskusaatavani rahaksi\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm.errorMessage ? _c('b-row', [_c('b-col', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', [_vm.step === 1 ? _c('b-button', {
    attrs: {
      "variant": _vm.buttonVariantData,
      "block": ""
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(this.buttonText1) + "\n\n            "), _vm._v(" "), _vm.showArrow ? _c('span', {
    staticClass: "submit-button-extend"
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.step === 2 ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": _vm.buttonVariantData,
      "block": ""
    }
  }, [_vm._v(_vm._s(this.buttonText2) + "\n\n            "), _vm._v(" "), _vm.showArrow ? _c('span', {
    staticClass: "submit-button-extend"
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  })]) : _vm._e()]) : _vm._e()], 1)], 1)], 1)])], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = __vue_component__; // Attach install function executed by Vue.use()

  installable.install = Vue => {
    Vue.component('CompanyLoanForm', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export default entry_esm;
